import { post } from "./http";
import axios from "axios";
import common from './constants';

let basic = common.interfacePath.serverTestUrl;

const uploadApi = {
	base64Url: `${basic}/basicdata/uploadbybase64`,
	url: `${basic}/basicdata/uploadbymultipart`,
	file: params => { return post(`/basicdata/uploadbymultipart`, params) },
	uploadFile: params => { return axios.request({
		url: '/basicdata/uploadbymultipart',
		method: 'post',
		data: params,
		headers: {
			"Content-Type": "multipart/form-data"
		}
	}) },
}
export default uploadApi;
